import React from "react";
import Page from "../../components/page";

function PageNotFound() {

  return (
    <Page>
      <h1 className="text-center mt-4">Pagina Non Trovata</h1>
    </Page>
  );
}

export default PageNotFound;
